import type { LabMarkerTVitalLabMarkerMetadataT as LabMarkerT } from '@lotushealth/lotushealth_js_sdk/schemas';

function getLabIdFromMarker(marker: LabMarkerT): string | null {
  const labId = marker.metadata.lab_info?.lab_id;
  return typeof labId === 'string' && labId.trim() !== '' ? labId : null;
}

export interface SameLabMarkersResult {
  ok: boolean;
  labId: string | null;
}

/**
 * Ensures all markers are from the same lab (by `metadata.lab_info.lab_id`).
 */
export function validateSameLabMarkers(markers: ReadonlyArray<LabMarkerT>): SameLabMarkersResult {
  const labIds = new Set(
    markers
      .map(getLabIdFromMarker)
      .filter((id): id is string => typeof id === 'string' && id.trim() !== '')
  );

  if (labIds.size <= 1) {
    const first = labIds.values().next().value;
    return { ok: true, labId: typeof first === 'string' ? first : null };
  }

  return { ok: false, labId: null };
}
